import React, { useState, useEffect } from "react";

import moment from "moment";
import { toast } from "react-toastify";
import Table from "./Component.js";

import DatePicker from "react-datepicker";
import "./datepicker_custom.css";
import { ko } from "date-fns/esm/locale";

import * as Constant from "../../../../Constant.js";

const ModifyContractTable = ({ tableId, bizApp, serviceAppList, appAuthTypeList, list, setList, changeList, isRecontractSeason, isNoContractSeason, isRecontractModal = false, seasonInfo }) => {
    const [recontractYear, setRecontractYear] = useState(false);
    useEffect(() => {
        if (!recontractYear) {
            const baseRecontractYear = moment(`${seasonInfo.recontractYear}-02-01`);
            // if(baseRecontractYear.isAfter(`${seasonInfo.recontractYear}-06-01`)) {
            //     baseRecontractYear.add(1, 'y');
            // }
            const nextYear = baseRecontractYear.add(1, "y").format("YYYY-MM-DD");
            const _recontractYear = {};
            Object.keys(bizApp).forEach((b) => {
                _recontractYear[b] = nextYear;
            });
            setRecontractYear(_recontractYear);
        }
        return () => {};
    }, [bizApp, serviceAppList, appAuthTypeList, list, seasonInfo]);

    if(!bizApp || !serviceAppList || !appAuthTypeList) {
        return <></>;
    }

    const recontractHandler = (app, idx, checked) => {
        const _list = [...list];
        const authIndex = _list[idx].app_auth[app];
        if (checked) {
            authIndex.recontract = recontractYear[app];
        } else {
            authIndex.recontract = null;
        }
        changeList(_list);
    };

    if(!serviceAppList || !bizApp) {
        return <></>;
    }
    
    const colSpanApp = serviceAppList.reduce((acc, a) => bizApp[a.key] ? (acc + (bizApp[a.key].fold ? 1 : 1 + bizApp[a.key].colAdd)) : acc, 0);
    return (
        <>
            <table className="table table-bordered table-contract table-contract-modify" id={tableId || "contractInfoTable"}>
                <Table.Header.Default bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {(!list || list.length === 0) && (
                        <tr className="table-contract-tr">
                            <td
                                style={{ backgroundColor: "#ffffff" }}
                                colSpan={
                                    4 +
                                    colSpanApp
                                }
                            >
                                계약이 존재하지 않습니다
                            </td>
                        </tr>
                    )}
                    {list.map((c, idx) => {
                        if (c.is555) return null;
                        const hasApproval = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval == "WT" || c.app_auth[a.key].approval == "AP") == true), false);
                        const hasApprovalOrg = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP") == true), false);
                        const unionId = Table.func.getUnionId(serviceAppList, appAuthTypeList, c.app_auth);
                        return (
                            <tr className="table-contract-tr" key={`table-contract-modify-tr-${idx}`}>
                                <td className="table-contract-td col-fixed" style={{}}>
                                    {c.user_id || "-"}
                                </td>
                                <td className="table-contract-td col-fixed" style={{ minWidth: "100px", textAlign: "left", whiteSpace: "nowrap" }}>
                                    {c.class_name}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    <Table.QuantityInput auth={hasApproval ? "AP" : "NA"} value={c.quantity} disabled={!hasApproval || !hasApprovalOrg} lock={!hasApproval}
                                        quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp.tomonote.info, list, idx, val, callback)}
                                        quantityHandler={(val) => Table.func.quantityHandler(bizApp.tomonote.info, list, idx, val, changeList)} />
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasApproval ? (
                                        <Table.DeviceSelect approval={hasApproval} approval_org={hasApprovalOrg} device={c.device} onSelectHandler={(val) => Table.func.deviceHandler(list, idx, val, changeList)} />
                                        )
                                        : <></>
                                    }
                                </td>
                                <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                    <Table.UnionSelect classAuth={c.app_auth} union={unionId} appAuthTypeList={appAuthTypeList}
                                        disabled={false}
                                        onSelectHandler={(val) => Table.func.unionHandler(appAuthTypeList, list, idx, val, setList)} />
                                </td>

                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            if(bizApp[a.key].hasPreContractedBranch) {
                                                return (
                                                    <>
                                                        {idx == 0 ? (
                                                            <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd} rowSpan={list.length}>
                                                                권한 없음
                                                            </td>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </>
                                                );
                                            } else {
                                                return (
                                                    <Table.ConfirmCell
                                                        bizApp={bizApp[a.key]}
                                                        fold={bizApp[a.key].fold}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        quantityMax={30}
                                                        auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                        auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                        canChangeNoAuth={isNoContractSeason || (c.app_auth[a.key] && c.app_auth[a.key].approval_org == "WT")}
                                                        authHandler={(auth) => {
                                                            const _list = list;
                                                            if (!_list[idx].app_auth[a.key]) {
                                                                _list[idx].app_auth[a.key] = {
                                                                    approval: "NA",
                                                                    authType: null,
                                                                    start_date: bizApp[a.key].start_date,
                                                                    end_date: bizApp[a.key].end_date,
                                                                };
                                                            }
                                                            const authIndex = _list[idx].app_auth[a.key];
                                                            if (_list[idx].id > 0 && authIndex.approval === "AP") {
                                                                if (auth.age === -1) {
                                                                    if (isNoContractSeason || authIndex.approval_org === "WT") {
                                                                        const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(a.key, list, idx);
                                                                        if(checkUnionOk || unbindUnionResult) {
                                                                            authIndex.approval = "NA";
                                                                            if(unbindUnionResult) {
                                                                                Table.func.unionHandler(appAuthTypeList, _list, idx, null, setList);
                                                                            }
                                                                        } else {
                                                                            return;
                                                                        }
                                                                    } else {
                                                                        alert("승인된 계정의 미사용 처리는 불가능합니다.");
                                                                        return;
                                                                    }
                                                                } else {
                                                                    _list[idx][a.age.field] = auth.age;
                                                                }
                                                            } else {
                                                                if (auth.age === -1) {
                                                                    const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(a.key, list, idx);
                                                                    if(checkUnionOk || unbindUnionResult) {
                                                                        authIndex.approval = "NA";
                                                                        if(unbindUnionResult) {
                                                                            Table.func.unionHandler(appAuthTypeList, _list, idx, null, setList);
                                                                        }
                                                                    } else {
                                                                        return;
                                                                    }
                                                                } else {
                                                                    authIndex.approval = (authIndex.approval_org === "NA" || authIndex.approval_org === "WT") ? "WT" : "AP";
                                                                    _list[idx][a.age.field] = auth.age;
                                                                }
                                                            }
                                                            changeList(_list);
                                                            if (authIndex.approval != "NA") {
                                                                bizApp[a.key].onChangeBizAppFold(a.key, bizApp, false);
                                                            }
                                                        }}
                                                        quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(a, list, idx, val, callback)}
                                                        quantityHandler={(val) => Table.func.quantityHandler(a, list, idx, val, changeList)}
                                                        startDate={new Date(c.app_auth[a.key] ? c.app_auth[a.key].start_date : null)}
                                                        endDate={new Date(c.app_auth[a.key] ? c.app_auth[a.key].end_date : null)}
                                                        endDateHandler={(date) => Table.func.endDateHandler(a.key, list, idx, date, changeList)}
                                                        disabled={!c.app_auth[a.key] || !(c.app_auth[a.key].approval_org === "AP" || c.app_auth[a.key].approval_org === "WT")}
                                                        is555={c.is555}
                                                        needRecontract={isRecontractSeason && c.app_auth[a.key] && c.app_auth[a.key].need_recontract > 0}
                                                        recontractEndDate={c.app_auth[a.key] ? c.app_auth[a.key].recontract : null}
                                                        recontractHandler={(checked) => recontractHandler(a.key, idx, checked)}
                                                    />
                                                );
                                            }
                                        }
                                    })
                                ) : (
                                    <></>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr className="table-contract-tr table-contract-tr-summary">
                            <td colSpan="2" className="bg-dark text-light text-center font-bold table-contract-td col-fixed">
                                합계
                            </td>
                            <td className="bg-dark text-light text-center font-bold table-contract-td">
                                {bizApp && bizApp.totalInfo ? bizApp.totalInfo.quantity : 0}명
                            </td>
                            <td className="bg-dark text-light text-center font-bold table-contract-td">
                            </td>
                            <td className="bg-dark text-light text-center font-bold table-contract-td">
                            </td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        if(bizApp[a.key].hasPreContractedBranch) {
                                            return (
                                                <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd} rowSpan={2}></td>
                                            );
                                        } else {
                                            if(bizApp[a.key].hasCellQuantity) {
                                                if(bizApp[a.key].fold) {
                                                    return (
                                                        <td style={{ backgroundColor: "#f9f9ff" }}>
                                                            {bizApp[a.key].count}개 / {bizApp[a.key].quantity}명
                                                        </td>
                                                    );
                                                } else {
                                                    return (
                                                        <>
                                                            <td style={{ backgroundColor: "#f9f9ff" }}>{bizApp[a.key].count}개</td>
                                                            <td style={{ backgroundColor: "#f9f9ff" }}>{bizApp[a.key].quantity}명</td>
                                                            <td style={{ backgroundColor: "#f9f9ff" }} />
                                                        </>
                                                    );
                                                }
                                            } else {
                                                return (
                                                    <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}>{bizApp[a.key].count}개</td>
                                                );
                                            }
                                        }
                                    }
                                }))
                                : <></>
                            }
                        </tr>
                        {isRecontractSeason && (
                            <tr className="table-contract-tr table-contract-tr-recontract">
                                <td colSpan="5" className="bg-dark text-center text-light font-bold table-contract-td col-fixed">
                                    재계약 적용 계약 기간
                                </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            if(bizApp[a.key].hasPreContractedBranch) {
                                                return (<></>);
                                            } else {
                                                return (
                                                    <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd} className="p-0">
                                                        {recontractYear[a.key] && (
                                                            <div className="row pl-3" style={{ minWidth: "105px", maxWidth: "105px" }}>
                                                                <div className="col" style={{ minWidth: "40px", maxWidth: "40px", padding: "10px" }}>
                                                                    <span className="text-center">~</span>
                                                                </div>
                                                                <div className="col p-0">
                                                                    <DatePicker
                                                                        className="form-control text-center border-0"
                                                                        selected={new Date(recontractYear[a.key])}
                                                                        onChange={(date) => {
                                                                            const _date = moment(date).format("YYYY-02-01");
                                                                            const _list = [...list];
                                                                            _list.forEach((c) => {
                                                                                if (c.app_auth[a.key] && c.app_auth[a.key].recontract) {
                                                                                    c.app_auth[a.key].recontract = _date;
                                                                                }
                                                                            });
        
                                                                            const _r = { ...recontractYear };
                                                                            _r[a.key] = _date;
                                                                            console.debug(_r);
        
                                                                            setRecontractYear(_r);
                                                                            changeList(_list);
                                                                        }}
                                                                        minDate={new Date()}
                                                                        dateFormat="yy-02"
                                                                        showYearPicker
                                                                        popperPlacement="left-end"
                                                                        yearItemNumber={6}
                                                                        locale={ko}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>
                                                );
                                            }
                                        }
                                    }))
                                    : <></>
                                }
                            </tr>
                        )}
                    </tfoot>
                )}
            </table>
        </>
    );
};

const MasterContractTable = ({ tableId, bizApp, serviceAppList, list, setList, changeList, branchName, appAuthTypeList }) => {
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, list]);

    const authHandler = (app, ageName, idx, auth) => {
        const _list = [...list];
        if (!_list[idx].app_auth[app]) {
            _list[idx].app_auth[app] = {
                approval: "NA",
                authType: null,
                start_date: bizApp[app].start_date,
                end_date: bizApp[app].end_date,
            };
        }

        const authIndex = _list[idx].app_auth[app];
        if (branchName[app]) {
            if(auth.age === -1) {
                const [checkUnionOk, unbindUnionResult] = Table.func.checkUnionUnbind(app, list, idx);
                if(checkUnionOk || unbindUnionResult) {
                    authIndex.approval = "NA";
                    if(unbindUnionResult) {
                        Table.func.unionHandler(appAuthTypeList, _list, idx, null, setList);
                    }
                } else {
                    return;
                }
            }
            authIndex.approval = auth.approval;
            if(auth.age != -1) {
                _list[idx][ageName] = auth.age;
            }
            authIndex.id = _list[idx].id;
        } else {
            alert(`${bizApp[app].info.name} 계약이 존재하는 지사가 없어 계약을 추가 할 수 없습니다.`);
        }

        setList(_list);
        if (authIndex.approval != "NA") {
            bizApp[app].onChangeBizAppFold(app, bizApp, false);
        }
    };

    let age = 0;
    let ageNum = 0;
    
    const colSpanApp = serviceAppList.reduce((acc, a) => bizApp[a.key] ? (acc + (bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd)) : acc, 0);

    return (
        <>
            <table className="table table-bordered table-contract table-contract-master" id={tableId || "contractInfoTable"}>
                <Table.Header.Default bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {(!list || list.length === 0) && (
                        <tr className="table-contract-tr">
                            <td
                                style={{ backgroundColor: "#ffffff" }}
                                colSpan={ 4 + colSpanApp }
                            >
                                위의 [반 추가] 버튼을 눌러 해당 연령의 계정을 추가해주세요.
                            </td>
                        </tr>
                    )}
                    {list.map((c, idx) => {
                        const changeAge = age === c.age;
                        if (!changeAge) {
                            age = c.age;
                            ageNum = 1;
                        } else {
                            ageNum++;
                        }
                        if (c.is555) return null;

                        const hasApproval = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval == "WT" || c.app_auth[a.key].approval == "AP") == true), false);
                        const hasApprovalOrg = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval_org == "WT" || c.app_auth[a.key].approval_org == "AP") == true), false);
                        return (
                            <tr className="table-contract-tr" style={{ borderTop: `${changeAge ? "1" : "1"}px solid #e6e6f2` }} key={`table-contract-tr-master-${idx}`}>
                                <td className="table-contract-td col-fixed" style={{}}>
                                    {c.user_id || "-"}
                                </td>
                                <td className="table-contract-td col-fixed" style={{ textAligh: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {c.class_name}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasApproval ? (
                                        <Table.QuantityInput auth={hasApproval ? "AP" : "NA"} value={c.quantity} disabled={!hasApproval} lock={!hasApproval} max={Constant.CONTRACT_LIMIT.QUANTITY.HQ}
                                            quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp.tomonote.info, list, idx, val, callback)}
                                            quantityHandler={(val) => Table.func.quantityHandler(bizApp.tomonote.info, list, idx, val, changeList)} />
                                    ) : (
                                        <>{c.quantity ? c.quantity : ''}</>
                                    )}
                                </td>
                                <td className="table-contract-td" style={{ textAlign: "left", minWidth: "100px", width: "120px", whiteSpace: "nowrap" }}>
                                    {hasApproval ? (
                                        <Table.DeviceSelect approval={hasApproval} approval_org={hasApprovalOrg} device={c.device} onSelectHandler={(val) => Table.func.deviceHandler(list, idx, val, changeList)} />
                                    ) : (
                                        <></>
                                    )}
                                </td>
                                <td className={`table-contract-td bg-union-70 ${'text-gray'}`} style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                    <Table.UnionSelect classAuth={c.app_auth} union={c.unionId} appAuthTypeList={appAuthTypeList}
                                        disabled={false}
                                        onSelectHandler={(val) => Table.func.unionHandler(appAuthTypeList, list, idx, val, changeList)} />
                                </td>
                                {serviceAppList ? (
                                    serviceAppList.map((a) => {
                                        if(a.contractUseTas && bizApp[a.key]) {
                                            return (
                                                <Table.ConfirmCell
                                                    bizApp={bizApp[a.key]}
                                                    fold={bizApp[a.key].fold}
                                                    age={c[a.age.field]}
                                                    quantity={c[a.quantity.field[0]]}
                                                    quantityMax={Constant.CONTRACT_LIMIT.QUANTITY.HQ}
                                                    auth={c.app_auth[a.key] ? c.app_auth[a.key].approval : "NA"}
                                                    auth_org={c.app_auth[a.key] ? c.app_auth[a.key].approval_org : "NA"}
                                                    canChangeNoAuth={true}
                                                    authHandler={(auth) => authHandler(a.key, a.age.field, idx, auth)}
                                                    quantityPreHandler={(val, callback) => Table.func.quantityPreHandler(bizApp[a.key].info, list, idx, val, callback)}
                                                    quantityHandler={(val) => Table.func.quantityHandler(bizApp[a.key].info, list, idx, val, changeList)}
                                                    startDate={new Date(c.app_auth[[a.key]] ? c.app_auth[[a.key]].start_date : null)}
                                                    startDateHandler={(date) => Table.func.startDateHandler(a.key, list, idx, date, changeList)}
                                                    endDate={new Date(c.app_auth[[a.key]] ? c.app_auth[[a.key]].end_date : null)}
                                                    endDateHandler={(date) => Table.func.endDateHandler(a.key, list, idx, date, changeList)}
                                                    disabled={!c.app_auth[[a.key]] || c.app_auth[[a.key]].approval_org === "NA"}
                                                    is555={c.is555}
                                                />
                                            );
                                        }
                                    })
                                ) : (
                                    <></>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr className="table-contract-tr">
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                                합계
                            </td>
                            <td className="bg-dark text-light text-center font-bold">
                                원아 합계
                            </td>
                            <td className="bg-dark text-light text-center font-bold">
                                {bizApp && bizApp.totalInfo ? bizApp.totalInfo.quantity : 0}명
                            </td>
                            <td style={{ backgroundColor: "#f9f9ff" }}>
                            </td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return bizApp[a.key] &&
                                            (bizApp[a.key].hasPreContractedBranch ? (
                                                <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}></td>
                                            ) : (
                                                <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}>
                                                    {bizApp[a.key].count}개{bizApp[a.key].hasCellQuantity ? ` / ${bizApp[a.key].quantity}명` : ''}
                                                </td>
                                            ));
                                    } else {
                                        return <></>;
                                    }
                                })
                            ) : (
                                <></>
                            )}
                        </tr>
                        <tr>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                                계약 지사
                            </td>
                            <td colSpan="2" className="bg-dark text-light text-center font-bold">
                            </td>
                            <td style={{ backgroundColor: "#f9f9ff" }}>
                            </td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return bizApp[a.key] &&
                                            (bizApp[a.key].hasPreContractedBranch ? (
                                                <td className="table-contract-td col-no-right" colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}></td>
                                            ) : (
                                                <td style={{ backgroundColor: "#f9f9ff" }} colSpan={bizApp[a.key].fold ? 1 : 2 + bizApp[a.key].colAdd}>
                                                    {branchName[a.key]}
                                                </td>
                                            ));
                                    } else {
                                        return <></>;
                                    }
                                })
                            ) : (
                                <></>
                            )}
                        </tr>
                    </tfoot>
                )}
            </table>
        </>
    );
};

const RecontractConfirmTable = ({ tableId, bizApp, serviceAppList, appAuthTypeList, list, seasonInfo }) => {
    useEffect(() => {}, [bizApp, serviceAppList, appAuthTypeList, list]);

    if(!seasonInfo, !bizApp || !serviceAppList) {
        return <></>;
    }

    const data = {};
    const ageSet = new Set();
    const recontractYearCheck = seasonInfo.recontractYear;

    if (list && list.length > 0) {
        list.forEach((c) => {
            const auth = c.app_auth;
            Object.keys(bizApp).forEach((a) => {
                if (auth[a] && auth[a].approval === "AP") {
                    const field = c[bizApp[a].info.age.field] != null ? bizApp[a].info.age.field : 'age';
                    let age = c[field];
                    ageSet.add(Number(age));
                    if (
                        auth[a].recontract_year < recontractYearCheck &&
                        moment(auth[a].end_date).get("year") <= recontractYearCheck && // 재계약 대상인지
                        auth[a].recontract
                    ) {
                        // 재계약 체크가 되었는지
                        const cnt = data[`${age}_${a}_recontract`] || 0;
                        const cnt2 = data[`${a}_recontract`] || 0;
                        data[`${age}_${a}_recontract`] = cnt + 1;
                        data[`${a}_recontract`] = cnt2 + 1;
                    } else if (moment(auth[a].end_date).get("year") > recontractYearCheck) {
                        const cnt = data[`${age}_${a}_contract`] || 0;
                        const cnt2 = data[`${a}_contract`] || 0;
                        data[`${age}_${a}_contract`] = cnt + 1;
                        data[`${a}_contract`] = cnt2 + 1;
                    }
                }
            });
        });
    }

    return (
        <>
            <table className="table table-bordered table-contract table-contract-re-confirm" id={tableId || "contractInfoTable"}>
                <Table.Header.RecontractConfirm bizApp={bizApp} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} />
                <tbody>
                    {Array.from(ageSet)
                        .sort((a, b) => a - b)
                        .map((age, idx) => {
                            return (
                                <tr className="table-contract-tr" style={{ borderTop: `1px solid #e6e6f2` }} key={`table-contract-tr-re-confirm-${idx}`}>
                                    <td className="bg-primary-light text-center text-dark">{Table.func.ageStr(age)}</td>
                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizApp[a.key]) {
                                                return (
                                                    <>
                                                        <td className="bg-light text-center">{data[`${age}_${a.key}_contract`] || 0}</td>
                                                        <td className="text-center">{data[`${age}_${a.key}_recontract`] || 0}</td>
                                                    </>
                                                );
                                            }
                                        })
                                    ) : <></>}
                                </tr>
                            );
                        })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr>
                            <td style={{ color: "#fff", backgroundColor: "#38419a" }}>소계</td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <>
                                                <td className="bg-primary-light text-center text-dark">{data[`${a.key}_contract`] || 0}개</td>
                                                <td className="bg-primary-light text-center text-dark">{data[`${a.key}_recontract`] || 0}개</td>
                                            </>
                                        );
                                    }
                                })
                            ) : <></>}
                        </tr>
                        <tr>
                            <td style={{ color: "#fff", backgroundColor: "#38419a" }}>총 계약 수량</td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <td className="bg-primary-light text-center text-dark" colSpan="2">
                                                {(data[`${a.key}_contract`] || 0) + (data[`${a.key}_recontract`] || 0)}개
                                            </td>
                                        );
                                    }
                                })
                            ) : <></>}
                        </tr>
                    </tfoot>
                )}
            </table>
        </>
    );
};

export default {
    ModifyTable: ModifyContractTable,
    MasterTable: MasterContractTable,
    RecontractConfirmTable: RecontractConfirmTable,
};
